module.exports = __webpack_public_path__ + "static/media/shield-1.9fabc182.glb";